#import "./MediaFull.graphql"
#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"

fragment ApplicationFull on Application {
  id
  tShirt {
    size
    gender
  }
  categories {
    confirmed
    paid
    price
    topped
    type
  }
  competitionId
  handlerId
  dogId
  paidAt
  note
  audio {
    ...MediaFull
  }
  team
  variableSymbol
  gdprApprovedAt
  recordingApprovedAt
  ...TimestampsFull
  ...SearchIndexFull
}
